export enum InputType {
  TEXT = 'text',
  PASSWORD = 'password',
  SELECT = 'select',
  CONTROL_MAPPING = 'control_mapping',
}
